require('./dataConcierge')
require('./requestModal')

require 'angular'

angular.module('workflow.app')
  .controller('ManualSourceRequestModalController', require './manualSourceRequestModalController')
  .controller('OrderModalController', require './orderModalController')
